import PartnerWorkExperienceForm from '../components/forms/AssessmentV2/PartnerWorkExperience';
import PartnerEducationForm from '../components/forms/AssessmentV2/PartnerEducationForm';
import JobOfferForm from '../components/forms/AssessmentV2/JobOfferForm';
import RelativesAbroadForm from '../components/forms/AssessmentV2/RelativesAbroadForm';
import GeneralInfo from 'components/forms/AssessmentV2/GeneralInfo';
import LanguageFormV2 from 'components/forms/AssessmentV2/LanguageFormV2';
import PartnerLanguageFormV2 from 'components/forms/AssessmentV2/PartnerLanguageFormV2';
import AdditionalDetails from 'components/forms/AssessmentV2/AdditionalDetails';
import SpousePartnerInfo from 'components/forms/AssessmentV2/SpousePartnerInfo';
import FamilyMembers from 'components/forms/AssessmentV2/FamilyMembers';
import BusinessOwnership from 'components/forms/AssessmentV2/BusinessOwnership';
import WorkExperienceV2 from 'components/forms/AssessmentV2/WorkExperienceV2';
import Education from 'components/forms/AssessmentV2/Education';
import * as S from './FormsFactory.styled';

export function FormsFactory(index: string, showSpouse: boolean, formPerc?: string) {
    let componentToRender = null;

    switch (index) {
        case 'Personal Info':
            componentToRender = <GeneralInfo />;
            break;
        case 'Additional Details':
            componentToRender = <AdditionalDetails />;
            break;
        case 'Spouse/Common Law Partner':
            componentToRender = <SpousePartnerInfo />;
            break;
        case 'Family Members':
            componentToRender = <FamilyMembers />;
            break;

        case 'Language Proficiency':
            componentToRender = showSpouse ? <PartnerLanguageFormV2 /> : <LanguageFormV2 />;
            break;
        case 'Education':
            componentToRender = showSpouse ? <PartnerEducationForm /> : <Education />;
            break;
        case 'Work Experience':
            componentToRender = showSpouse ? <PartnerWorkExperienceForm /> : <WorkExperienceV2 />;
            break;
        case 'Job Offer':
            componentToRender = <JobOfferForm />;
            break;
        case 'Relatives Abroad':
            componentToRender = <RelativesAbroadForm />;
            break;
        case 'Business Ownership':
            componentToRender = <BusinessOwnership />;
            break;

        default:
            componentToRender = <GeneralInfo />;
            break;
    }

    const progressBarWithComponent = <S.FormsContainer>{componentToRender}</S.FormsContainer>;

    return progressBarWithComponent;
}
